export enum AIAvatar {
    MEG_FORMAL = "MEG-FORMAL",
    LORI_GRACEFUL = "LORI-GRACEFUL",
    MAX_CASUAL = "MAX-CASUAL",
    NO_AVATAR = "NO_AVATAR"
}
